export const TEST_ID = 'applicationsGridHeader';
